import React, { useEffect, useState } from "react";
import Icon from "../elements/Icon";

const IconLoader: React.FC<{
  icon?: string;
  size?: number;
  iconShow?: boolean;
}> = ({ icon, size, iconShow }) => {
  const [showIcon, setShowIcon] = useState(iconShow);

  useEffect(() => {
    const timer = setTimeout(() => setShowIcon(true), 2000);
    return () => clearTimeout(timer);
  }, []);

  return showIcon && icon ? (
    <Icon type={icon} />
  ) : (
    <img
      src="/images/icons/spinner.svg"
      style={{ width: size || 21, height: size || 21 }}
      alt="icon loader"
    />
  );
};

export default IconLoader;
